import * as TooltipPrimitive from '@radix-ui/react-tooltip';
import { type ComponentProps, type ReactNode } from 'react';

import { cn } from '@/lib/utils/cn';

export const TooltipProvider = TooltipPrimitive.Provider;

interface TooltipProps {
  content: ReactNode;
  children: ReactNode;
  side?: ComponentProps<typeof TooltipPrimitive.Content>['side'];
  /** When true the tooltip is not rendered (children pass through). */
  disabled?: boolean;
}

export function Tooltip({ content, children, side = 'right', disabled = false }: TooltipProps) {
  if (disabled) return <>{children}</>;
  return (
    <TooltipPrimitive.Root>
      <TooltipPrimitive.Trigger asChild>{children}</TooltipPrimitive.Trigger>
      <TooltipPrimitive.Portal>
        <TooltipPrimitive.Content
          side={side}
          sideOffset={8}
          className={cn(
            'z-50 animate-fade-in rounded-md bg-foreground px-2 py-1 text-xs font-medium text-surface shadow-overlay',
          )}
        >
          {content}
        </TooltipPrimitive.Content>
      </TooltipPrimitive.Portal>
    </TooltipPrimitive.Root>
  );
}
